import type { NodeDefinition } from "../domain/types/index.js";

function node(id: string, kind: NodeDefinition["kind"], x: number, y: number, next: readonly string[]): NodeDefinition {
  return { id, kind, x, y, next, ...(kind === "case" ? { caseId: id === "boss" ? "recovery-boss" : id } : {}) };
}

// 第16期。障害・滞留・疲労の3地域を局所接続し、選んだ復旧方針を後半まで残す。
export const MAP_NODES_RECOVERY: Record<string, NodeDefinition> = Object.fromEntries([
  node("start", "start", 3, 0, ["p16-detect"]),
  node("p16-detect", "case", 3, 1, ["p16-drill"]),
  node("p16-drill", "case", 3, 2, ["p16-outage", "p16-backlog", "p16-pressure"]),

  node("p16-outage", "case", 1, 3, ["p16-isolate", "p16-rest-left"]),
  node("p16-isolate", "case", 0, 4, ["p16-restore-left"]),
  node("p16-rest-left", "rest", 2, 4, ["p16-restore-left"]),
  node("p16-restore-left", "case", 1, 5, ["p16-large-left", "p16-fallback"]),
  node("p16-large-left", "case", 0, 6, ["p16-verify-left"]),
  node("p16-fallback", "rest", 2, 6, ["p16-verify-left"]),
  node("p16-verify-left", "case", 1, 7, ["p16-rest-left2", "p16-transfer"]),
  node("p16-rest-left2", "rest", 0, 8, ["p16-stabilize-left"]),
  node("p16-transfer", "case", 2, 8, ["p16-coordinate"]),
  node("p16-stabilize-left", "case", 1, 9, ["p16-monitor-left"]),

  node("p16-backlog", "case", 3, 3, ["p16-triage", "p16-relic"]),
  node("p16-triage", "case", 3, 4, ["p16-clearance"]),
  node("p16-relic", "relic", 4, 4, ["p16-clearance"]),
  node("p16-clearance", "case", 3, 5, ["p16-large-center", "p16-relic-center"]),
  node("p16-large-center", "case", 3, 6, ["p16-reconcile"]),
  node("p16-relic-center", "relic", 4, 6, ["p16-reconcile"]),
  node("p16-reconcile", "case", 3, 7, ["p16-transfer", "p16-handoff"]),
  node("p16-handoff", "case", 4, 8, ["p16-coordinate"]),
  node("p16-coordinate", "case", 3, 9, ["p16-monitor-center"]),

  node("p16-pressure", "case", 5, 3, ["p16-escalation", "p16-night-shift"]),
  node("p16-escalation", "case", 5, 4, ["p16-support"]),
  node("p16-night-shift", "case", 6, 4, ["p16-support"]),
  node("p16-support", "case", 5, 5, ["p16-reassign", "p16-large-right"]),
  node("p16-reassign", "case", 5, 6, ["p16-verify-right"]),
  node("p16-large-right", "case", 6, 6, ["p16-verify-right"]),
  node("p16-verify-right", "case", 5, 7, ["p16-handoff", "p16-rest-right2"]),
  node("p16-rest-right2", "rest", 6, 8, ["p16-stabilize-right"]),
  node("p16-stabilize-right", "case", 5, 9, ["p16-monitor-right"]),

  node("p16-monitor-left", "case", 1, 10, ["p16-final-left"]),
  node("p16-monitor-center", "case", 3, 10, ["p16-final-left", "p16-final-right"]),
  node("p16-monitor-right", "case", 5, 10, ["p16-final-right"]),
  node("p16-final-left", "case", 2, 11, ["p16-continuity-left"]),
  node("p16-final-right", "case", 4, 11, ["p16-continuity-right"]),
  node("p16-continuity-left", "case", 2, 12, ["boss"]),
  node("p16-continuity-right", "case", 4, 12, ["boss"]),
  node("boss", "case", 3, 14, []),
].map(n => [n.id, n]));
